import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"compass-square, browser, safari, web, internet, navigation"} maskId="square-filled-radius-0-stroke-1-IconCompassSquare"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM9.78757 9.78753L15.3187 8.6813L14.2125 14.2125L8.68134 15.3187L9.78757 9.78753Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCompassSquare;
